export interface MenuItemBadge {
  text: string
  variant?: "primary" | "success" | "danger" | "warning"
}

export interface MenuItemChild {
  key: string
  label: string
  url: string
  icon?: string
  parentKey?: string
  badge?: MenuItemBadge
  roles?: string[]
  children?: MenuItemChild[]
}

export interface MenuItem {
  key?: string
  label: string
  isTitle?: boolean
  icon?: string
  url?: string
  badge?: MenuItemBadge
  roles?: string[]
  children?: MenuItemChild[]
}

export const menuData: MenuItem[] = [
  { isTitle: true, label: "Main" },
  {
    key: "dashboard",
    label: "Dashboard",
    icon: "mdi mdi-view-dashboard",
    url: "/dashboard",
    // badge: { text: "2", variant: "primary" },
  },


  {
    key: "crm",
    label: "CRM",
    icon: "mdi mdi-account-group",
    url: "/crm",
    roles: ["Super-admin", "Admin", "Seller", "Broker"]
  },
  {
    key: "live-properties",
    label: "Live Properties",
    icon: "mdi mdi-play-circle",
    url: "/live-properties",
  },
  {
    key: "listings",
    label: "Listings",
    icon: "mdi mdi-domain",
    url: "/listings",
    roles: ["Super-admin", "Admin", "Seller", "Broker"]
  },
  {
    key: "bidding-overview",
    label: "Bidding Overview",
    icon: "mdi mdi-gavel",
    url: "/bidding-overview",
    roles: ["Super-admin", "Admin"]
  },
  {
    key: "closed-bidding",
    label: "Closed Bidding",
    icon: "mdi mdi-flag-checkered",
    url: "/closed-bidding",
    roles: ["Super-admin", "Admin", "Seller", "Broker"]
  },
  // {
  //   key: "bid-property",
  //   label: "Bid on Property",
  //   icon: "mdi mdi-cash-plus",
  //   url: "/bid",
  // },
  {
    key: "my-bids",
    label: "My Bids",
    icon: "mdi mdi-history",
    url: "/my-bids",
  },
  {
    key: "master",
    label: "Masters",
    icon: "mdi mdi-cog-outline",
    url: "/#",
    roles: ["Super-admin", "Admin"],
    children: [
      {
        key: "users",
        label: "Users",
        icon: "mdi mdi-account-multiple",
        url: "/users",
        parentKey: "master",
        roles: ["Super-admin", "Admin"]
      },
    ],
  },



  // { isTitle: true, label: "Lead Management" },






  // {
  //   key: "calendar",
  //   label: "Calendar",
  //   icon: "mdi mdi-calendar-check",
  //   url: "/calendar",
  // },
  // {
  //   key: "email",
  //   label: "Email",
  //   icon: "mdi mdi-email-outline",
  //   url: "/#",
  //   children: [
  //     {
  //       key: "email-inbox",
  //       label: "Inbox",
  //       url: "/email-inbox",
  //       parentKey: "email"
  //     },
  //     {
  //       key: "email-read",
  //       label: "Email Read",
  //       url: "/email-read",
  //       parentKey: "email"
  //     },
  //     {
  //       key: "email-compose",
  //       label: "Email Compose",
  //       url: "/email-compose",
  //       parentKey: "email"
  //     },
  //   ],
  // },
  // {
  //   key: "chat",
  //   label: "Chat",
  //   icon: "mdi mdi-chat-processing-outline",
  //   url: "/chat",
  //   badge: {
  //     text: "Hot",
  //     variant: "danger"
  //   },
  // },


  // { isTitle: true, label: "Components" },
  // {
  //   key: "ui-elements",
  //   label: "UI Elements",
  //   icon: "mdi mdi-buffer",
  //   url: "/#",
  //   children: [
  //     {
  //       key: "ui-alerts",
  //       label: "Alerts",
  //       url: "/ui-alerts",
  //       parentKey: "ui-elements"
  //     },
  //     {
  //       key: "ui-buttons",
  //       label: "Buttons",
  //       url: "/ui-buttons",
  //       parentKey: "ui-elements"
  //     },
  //     {
  //       key: "ui-badge",
  //       label: "Badge",
  //       url: "/ui-badge",
  //       parentKey: "ui-elements"
  //     },
  //     {
  //       key: "ui-cards",
  //       label: "Cards",
  //       url: "/ui-cards",
  //       parentKey: "ui-elements"
  //     },
  //     {
  //       key: "ui-carousel",
  //       label: "Carousel",
  //       url: "/ui-carousel",
  //       parentKey: "ui-elements"
  //     },
  //     {
  //       key: "ui-dropdowns",
  //       label: "Dropdowns",
  //       url: "/ui-dropdowns",
  //       parentKey: "ui-elements"
  //     },
  //     {
  //       key: "ui-utilities",
  //       label: "Utilities",
  //       url: "/ui-utilities",
  //       parentKey: "ui-elements",
  //       badge: {
  //         text: "New",
  //         variant: "success"
  //       }
  //     },
  //     {
  //       key: "ui-grid",
  //       label: "Grid",
  //       url: "/ui-grid",
  //       parentKey: "ui-elements"
  //     },
  //     {
  //       key: "ui-images",
  //       label: "Images",
  //       url: "/ui-images",
  //       parentKey: "ui-elements"
  //     },
  //     {
  //       key: "ui-lightbox",
  //       label: "Lightbox",
  //       url: "/ui-lightbox",
  //       parentKey: "ui-elements"
  //     },
  //     {
  //       key: "ui-modals",
  //       label: "Modals",
  //       url: "/ui-modals",
  //       parentKey: "ui-elements"
  //     },
  //     {
  //       key: "ui-colors",
  //       label: "Colors",
  //       url: "/ui-colors",
  //       parentKey: "ui-elements",
  //       badge: {
  //         text: "New",
  //         variant: "warning"
  //       }
  //     },
  //     { key: "ui-offcanvas", label: "Offcanvas", url: "/ui-offcanvas", parentKey: "ui-elements", badge: { text: "New", variant: "warning" } },
  //     {
  //       key: "ui-pagination",
  //       label: "Pagination", url: "/ui-pagination", parentKey: "ui-elements"
  //     },
  //     { key: "ui-popover-tooltip", label: "Popover & Tooltips", url: "/ui-popover-tooltip", parentKey: "ui-elements" },
  //     {
  //       key: "ui-rangeslider",
  //       label: "Range Slider", url: "/ui-rangeslider", parentKey: "ui-elements"
  //     },
  //     { key: "ui-session-timeout", label: "Session Timeout", url: "/ui-session-timeout", parentKey: "ui-elements" },
  //     {
  //       key: "ui-progressbars", label: "Progress Bars",
  //       url: "/ui-progressbars", parentKey: "ui-elements"
  //     },
  //     { key: "ui-tabs-accordions", label: "Tabs & Accordions", url: "/ui-tabs-accordions", parentKey: "ui-elements" },
  //     { key: "ui-typography", label: "Typography", url: "/ui-typography", parentKey: "ui-elements" },
  //     { key: "ui-video", label: "Video", url: "/ui-video", parentKey: "ui-elements" },
  //   ],
  // },
  // {
  //   key: "forms",
  //   label: "Forms",
  //   icon: "mdi mdi-clipboard-outline",
  //   url: "/#",
  //   badge: { text: "6", variant: "success" },
  //   children: [
  //     { key: "form-elements", label: "Form Elements", url: "/form-elements", parentKey: "forms" },
  //     { key: "form-validation", label: "Form Validation", url: "/form-validation", parentKey: "forms" },
  //     { key: "form-advanced", label: "Form Advanced", url: "/form-advanced", parentKey: "forms" },
  //     { key: "form-editors", label: "Form Editors", url: "/form-editors", parentKey: "forms" },
  //     { key: "form-uploads", label: "Form File Upload", url: "/form-uploads", parentKey: "forms" },
  //   ],
  // },
  // {
  //   key: "charts",
  //   label: "Charts",
  //   icon: "mdi mdi-chart-line",
  //   url: "/#",
  //   children: [
  //     { key: "apex-charts", label: "Apex charts", url: "/apex-charts", parentKey: "charts" },
  //     { key: "sparkline-charts", label: "Sparkline Chart", url: "/sparkline-charts", parentKey: "charts" },
  //     { key: "charts-knob", label: "Jquery Knob Chart", url: "/charts-knob", parentKey: "charts" },
  //   ],
  // },
  // {
  //   key: "tables",
  //   label: "Tables",
  //   icon: "mdi mdi-format-list-bulleted-type",
  //   url: "/#",
  //   children: [
  //     { key: "tables-basic", label: "Basic Tables", url: "/tables-basic", parentKey: "tables" },
  //     { key: "tables-datatable", label: "Data Tables", url: "/tables-datatable", parentKey: "tables" },
  //     { key: "tables-responsive", label: "Responsive Table", url: "/tables-responsive", parentKey: "tables" },
  //   ],
  // },
  // {
  //   key: "icons",
  //   label: "Icons",
  //   icon: "mdi mdi-album",
  //   url: "/#",
  //   children: [
  //     { key: "icons-materialdesign", label: "Material Design", url: "/icons-materialdesign", parentKey: "icons" },
  //     { key: "icons-ion", label: "Ion Icons", url: "/icons-ion", parentKey: "icons" },
  //     { key: "icons-fontawesome", label: "Font Awesome", url: "/icons-fontawesome", parentKey: "icons" },
  //     { key: "icons-themify", label: "Themify Icons", url: "/icons-themify", parentKey: "icons" },
  //     { key: "icons-dripicons", label: "Dripicons", url: "/icons-dripicons", parentKey: "icons" },
  //     { key: "icons-typicons", label: "Typicons Icons", url: "/icons-typicons", parentKey: "icons" },
  //   ],
  // },
  // {
  //   key: "maps",
  //   label: "Maps",
  //   icon: "mdi mdi-google-maps",
  //   url: "/#",
  //   badge: { text: "2", variant: "danger" },
  //   children: [
  //     { key: "maps-google", label: "Google Maps", url: "/maps-google", parentKey: "maps" },
  //     { key: "maps-vector", label: "Vector Maps", url: "/maps-vector", parentKey: "maps" },
  //   ],
  // },











  // { isTitle: true, label: "Extras" },
  // {
  //   key: "authentication",
  //   label: "Authentication",
  //   icon: "mdi mdi-account-box",
  //   url: "/#",
  //   children: [
  //     { key: "pages-login", label: "Login", url: "/pages-login", parentKey: "authentication" },
  //     { key: "pages-register", label: "Register", url: "/pages-register", parentKey: "authentication" },
  //     { key: "page-recoverpw", label: "Recover Password", url: "/page-recoverpw", parentKey: "authentication" },
  //     { key: "auth-lock-screen", label: "Lock Screen", url: "/auth-lock-screen", parentKey: "authentication" },
  //   ],
  // },
  // {
  //   key: "extra-pages",
  //   label: "Extra Pages",
  //   icon: "mdi mdi-text-box-multiple-outline",
  //   url: "/#",
  //   children: [
  //     { key: "pages-timeline", label: "Timeline", url: "/pages-timeline", parentKey: "extra-pages" },
  //     { key: "pages-invoice", label: "Invoice", url: "/pages-invoice", parentKey: "extra-pages" },
  //     { key: "pages-directory", label: "Directory", url: "/pages-directory", parentKey: "extra-pages" },
  //     { key: "pages-blank", label: "Blank Page", url: "/pages-blank", parentKey: "extra-pages" },
  //     { key: "pages-404", label: "Error 404", url: "/pages-404", parentKey: "extra-pages" },
  //     { key: "pages-500", label: "Error 500", url: "/pages-500", parentKey: "extra-pages" },
  //   ],
  // },
  // {
  //   key: "multi-level",
  //   label: "Multi Level",
  //   icon: "mdi mdi-share-variant",
  //   url: "/#",
  //   children: [
  //     { key: "level-1-1", label: "Level 1.1", url: "/#", parentKey: "multi-level" },
  //     {
  //       key: "level-1-2",
  //       label: "Level 1.2",
  //       url: "/#",
  //       parentKey: "multi-level",
  //       children: [
  //         { key: "level-2-1", label: "Level 2.1", url: "/#", parentKey: "level-1-2" },
  //         { key: "level-2-2", label: "Level 2.2", url: "/#", parentKey: "level-1-2" },
  //       ],
  //     },
  //   ],
  // },
]
